import React, { FC, useEffect } from 'react'
import Button from '../../../../../components/Atoms/Button/Button'
import useForm, { OnSubmitParams } from '../../../../../components/Core/Hooks/useForm/useForm'
import {
  FormStyle,
  FormHeader,
  FormTitle,
  FormDescription,
  FormFooter,
  FormFooterActionsLeft,
  FormFooterActionsRight,
} from '../../../../../components/Organisms/Form/Form.styles'
import utils from '../../../../../components/Organisms/Form/utils'
import config from './config'
import t from '../../../../../translations/main'
import { FormProps } from '../../../../Pages/Onboarding/types'
import { Trans } from 'react-i18next'

const RepresentationsForm: FC<FormProps> = props => {
  const submitForm = ({data, options}: OnSubmitParams) => {
    const { submit } = props
    if (submit) submit({ data, options })
  }

  const {
    formData,
    setFormData,
    handleInputChange,
    handleSubmit,
    toggleShowByVisualName,
    toggleShowBySecondaryName,
    configData,
  } = useForm(
    props.fetchedData,
    config,
    submitForm
  )

  useEffect(() => {

    toggleShowBySecondaryName(
      'eReasonForYouTradeCommodityDerivaties',
      ['nonFinancialCounterpartyAbove', 'nonFinancialCounterpartyBelow'].includes(formData?.eTradingDerivativeProduct?.value)
        ? `eReasonForYouTradeCommodityDerivaties-${formData?.eTradingDerivativeProduct?.value}` : ''
    )

    if (!['nonFinancialCounterpartyAbove', 'nonFinancialCounterpartyBelow'].includes(formData?.eTradingDerivativeProduct?.value)) {
      setFormData(prevState => ({
        ...prevState,
        eReasonForYouTradeCommodityDerivaties: {
          ...prevState?.eReasonForYouTradeCommodityDerivaties,
          value: '',
          required: true
        }
      }))
    }

    toggleShowByVisualName(
      'nonFinancialCounterpartyAbove-accordion',
      formData?.eTradingDerivativeProduct?.value === 'nonFinancialCounterpartyAbove' ? 'true' : 'false'
    )

    toggleShowByVisualName(
      'nonFinancialCounterpartyBelow-accordion',
      formData?.eTradingDerivativeProduct?.value === 'nonFinancialCounterpartyBelow' ? 'true' : 'false'
    )

  }, [formData?.eTradingDerivativeProduct?.value])

  return (
    <FormStyle onSubmit={handleSubmit}>
      <FormHeader>
        <FormTitle>
          {t('onboarding.forms.CorporateAccount.RepresentationsForm.title')}
        </FormTitle>
        <FormDescription>
          {/* @ts-ignore-next-line */}
          <Trans i18nKey='onboarding.forms.CorporateAccount.RepresentationsForm.description' />
        </FormDescription>
      </FormHeader>
      {utils.sectionBuilder(configData, formData, handleInputChange)}
      <FormFooter noOfButtons={2}>
        <FormFooterActionsLeft>
          <Button
            label={t('onboarding.main.backButton')}
            version={2}
            disabled={props.disablePrev}
            onClick={props.prevStep}
          />
        </FormFooterActionsLeft>
        <FormFooterActionsRight>
          <Button
            type='submit'
            label={props.isLastForm ? t('onboarding.main.saveAndSubmit') : t('onboarding.main.continueButton')}
            disabled={formData.eTradingDerivativeProduct.value === '' ||
            (['nonFinancialCounterpartyAbove', 'nonFinancialCounterpartyBelow'].includes(formData.eTradingDerivativeProduct.value) && formData.eReasonForYouTradeCommodityDerivaties.value === '')}
          />
        </FormFooterActionsRight>
      </FormFooter>
    </FormStyle>
  )
}

export default RepresentationsForm
